const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Корпоративен офис",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Ветеринарна практика",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Задължително",
    },
  },
  salutation: {
    label: "Обръщение",
    placeholder: "Изберете обръщение",
    errors: {
      required: "Обръщението е задължително",
      invalid: "Моля, изберете валидно обръщение",
    },
  },
  firstName: {
    label: "Име",
    placeholder: "Иван",
    errors: {
      authenticatedNameUpdateTrial:
        "Влезли сте в профила си и името ви не може да бъде променено.",
      required: "Името е задължително",
      minLength: "Името трябва да бъде поне 2 символа",
      maxLength: "Името трябва да бъде максимум 50 символа",
    },
  },
  lastName: {
    label: "Фамилия",
    placeholder: "Иванов",
    errors: {
      authenticatedNameUpdateTrial:
        "Влезли сте в профила си и името ви не може да бъде променено.",
      required: "Фамилията е задължителна",
      minLength: "Фамилията трябва да бъде поне 2 символа",
      maxLength: "Фамилията трябва да бъде максимум 50 символа",
    },
  },
  email: {
    label: "Имейл",
    placeholder: "ivan.ivanov@example.bg",
    description: "Моля, въведете личен имейл адрес, а не споделен имейл адрес.",
    prefixWarningTitle: "Открита споделена пощенска кутия",
    prefixWarningDescription:
      "Препоръчваме използването на личен имейл адрес за по-добро и персонализирано изживяване",
    errors: {
      authenticatedEmailUpdateTrial:
        "Влезли сте в профила си и имейл адресът ви не може да бъде променен.",
      required: "Имейлът е задължителен",
      invalidEmail: "Моля, въведете валиден имейл адрес",
      emailAssociatedWithYourAccount:
        "Вашият имейл адрес е свързан с вашия акаунт и не може да бъде променен.",
    },
  },
  confirmEmail: {
    label: "Потвърдете имейл",
    placeholder: "ivan.ivanov@example.bg",
    errors: {
      authenticatedEmailUpdateTrial:
        "Влезли сте в профила си и имейл адресът ви не може да бъде променен.",
      required: "Потвърждението на имейла е задължително",
      invalidEmail: "Моля, въведете валиден имейл адрес",
      emailMatchError: "Имейл адресите не съвпадат",
    },
  },
  password: {
    label: "Парола",
    placeholder: "Въведете вашата парола",
    errors: {
      required: "Паролата е задължителна",
    },
  },
  confirmPassword: {
    label: "Потвърдете парола",
    placeholder: "Потвърдете вашата парола",
    errors: {
      required: "Потвърждението на паролата е задължително",
      passwordMatchError: "Паролите не съвпадат",
    },
  },
  addressLine1: {
    label: "Адрес ред 1",
    placeholder: "ул. Витоша 123",
    errors: {
      required: "Адрес ред 1 е задължителен",
      minLength: "Адрес ред 1 трябва да бъде поне 5 символа",
      maxLength: "Адрес ред 1 трябва да бъде максимум 100 символа",
    },
  },
  addressLine2: {
    label: "Адрес ред 2",
    placeholder: "Апартамент 4B",
    errors: {
      required: "Адрес ред 2 е задължителен",
      maxLength: "Адрес ред 2 трябва да бъде максимум 100 символа",
    },
  },
  city: {
    label: "Град",
    placeholder: "София",
    errors: {
      required: "Градът е задължителен",
      minLength: "Градът трябва да бъде поне 2 символа",
      maxLength: "Градът трябва да бъде максимум 50 символа",
    },
  },
  country: {
    label: "Държава",
    placeholder: "Изберете държава",
    errors: {
      required: "Държавата е задължителна",
      invalid: "Моля, изберете валидна държава",
    },
  },
  state: {
    label: "Щат",
    placeholder: "Изберете щат",
    errors: {
      required: "Щатът е задължителен",
      invalid: "Моля, изберете валиден щат",
    },
  },
  jurisdiction: {
    label: "Юрисдикция на лиценза",
    placeholder: "Изберете юрисдикция на лиценза",
    errors: {
      required: "Юрисдикцията на лиценза е задължителна",
      invalid: "Моля, изберете валидна юрисдикция",
    },
  },
  zipCode: {
    label: "Пощенски код",
    placeholder: "1000",
    errors: {
      required: "Пощенският код е задължителен",
      invalid: "Моля, въведете валиден пощенски код",
    },
  },
  role: {
    label: "Роля",
    placeholder: "Изберете вашата роля",
    errors: {
      required: "Моля, изберете вашата роля",
      invalid: "Моля, изберете валидна роля",
    },
  },
  businessType: {
    label: "Тип бизнес",
    placeholder: "Изберете тип бизнес",
    errors: {
      required: "Типът бизнес е задължителен",
      invalid: "Моля, изберете валиден тип бизнес",
    },
  },
  businessName: {
    label: "Име на фирма",
    placeholder: "Въведете име на фирма",
    errors: {
      required: "Името на фирмата е задължително",
      minLength: "Името на фирмата трябва да бъде поне 2 символа",
      maxLength: "Името на фирмата трябва да бъде максимум 100 символа",
    },
  },
  businessSearch: {
    label: "Търсене на фирма:",
    addNewAccount: "Добавете нов фирмен акаунт",
    canNotFindBusiness: "Не намирате вашата фирма?",
    guideline:
      "Моля, въведете пощенския си код и тогава изберете от списъка по-долу.",
    guidelineForNameSearch:
      "Моля, въведете пълното име на фирмата и тогава изберете от списъка.",
    placeholder: "Къде работите?",
    noResults: "Няма намерени резултати",
    searching: "Търсене...",
    selectedBusinessHeading: "Избрана фирма:",
    selectedBusinessNotCorrect: "Не е правилно?",
    selectedBusinessTryAgain: "Опитайте отново",
    selectedBusinessDismiss: "Отхвърлете фирма",
    resultsFound: {
      singular: "1 фирма е намерена",
      plural: "Няколко фирми са намерени",
    },
    errors: {
      network:
        "Имаме проблеми с връзката към услугата за търсене на фирми. Моля, опитайте отново по-късно.",
    },
  },
  explicitConsent: {
    label:
      "Като маркирам това квадратче, се съгласявам да получавам маркетингови съобщения от Elanco.",
    errors: {
      required: "Необходимо е съгласие",
    },
  },
  explicitSmsConsent: {
    label:
      "Като маркирам това квадратче, се съгласявам да получавам маркетингови съобщения от Elanco чрез SMS/текстово съобщение.",
    errors: {
      required: "Съгласието за SMS е задължително",
    },
  },
  telephone: {
    label: "Личен телефон",
    placeholder: "Въведете личния си телефон",
    dialCodeLabel: "Код",
    dialCodePlaceholder: "Търсене на държава…",
    errors: {
      invalid: "Моля, въведете валиден телефонен номер.",
    },
  },
  businessTelephone: {
    label: "Фирмен телефон",
    placeholder: "Въведете фирмения си телефон",
    dialCodeLabel: "Код",
    dialCodePlaceholder: "Търсене на държава…",
    errors: {
      invalid: "Моля, въведете валиден телефонен номер.",
    },
  },
  professionalNumber: {
    label: "Професионален номер",
    placeholder: "1234567",
    errors: {
      required: "Моля, въведете професионален номер",
      maxLength: "Въведеното надхвърля лимита на символите",
    },
  },
  addressSearch: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  businessSearchField: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  checkbox: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  combobox: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  datePicker: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  dateRange: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  dateTime: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  emailField: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  fileInput: {
    errors: {
      required: "Моля, изберете файл",
    },
  },
  number: {
    errors: {
      required: "Моля, въведете число",
      minValue: "Моля, въведете стойност, по-голяма от минималната",
      maxValue: "Моля, въведете стойност, по-малка от максималната",
    },
  },
  passwordField: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  rangeSlider: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  select: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  telephoneField: {
    errors: {
      required: "Моля, въвеждайте само цифри",
      invalidTelephone: "Моля, въведете валиден телефонен номер",
      invalidFormat: "Невалиден формат на номер",
    },
  },
  text: {
    errors: {
      required: "Моля, използвайте само букви (A-Z), цифри (0-9) и без символи",
      maxLength: "Въведеното надхвърля лимита на символите",
      minLength: "Въведеното трябва да бъде поне 2 символа",
    },
  },
  textarea: {
    characters: "символа",
  },
  time: {
    errors: {
      required: "Това полето е задължително",
    },
  },
  form: {
    errors: {
      generic:
        "Възникна грешка при изпращане на формуляра. Моля, опитайте отново.",
      reportAnIssue: "Моля, докладвайте проблем.",
      configuration: "Грешка в конфигурацията",
      noFormQuestionsAvailable: "Няма налични въпроси във формуляра.",
      formComponentLoad:
        "Компонентът на формуляра не може да се зареди поради неподдържано поле.",
      code: "Код",
      type: "Тип",
      missingRequiredFields:
        "Във формуляра липсват задължителни полета (Имейл и/или Съгласие). Моля, свържете се с администратор, за да коригирате конфигурацията на формуляра.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Eläintensuojelu - Ветеринар",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Производител - смесено/друго",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Търговец на дребно",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Овцевъд",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Ветеринар",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Ветеринар", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Ветеринар, Vastanoton omistaja",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Ветеринарavustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Ветеринарasema - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Ветеринарasema - Ветеринар",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Ветеринарasema - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Ветеринарasiantuntija",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Ветеринар",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Господин",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Господин",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Госпожа",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Госпожа/Neiti",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Професор",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
